// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__1vZdx","detail":"style_detail__3SvIH"};